import { Paragraph } from 'components/atoms/Paragraph/Paragraph';
import { LANGUAGE_SETTINGS } from 'en';
import { RolandTable } from '../RolandTable/RolandTable';
import './_TableSection.scss';
import {
  PATCHES_TABLE,
  SOLUTIONS_TABLE,
  VIRTUAL_INSTRUMENTS_TABLE,
  SOFTWARE_EFFECTS,
  ZENOLOGY_TABLE,
  JAM_TRACKS_TABLE,
  SAMPLE_CONTENT_TABLE,
} from './tables';

export const TableSection = () => (
  <div className='table-section'>
    <div className='table-section__container'>
      <RolandTable table={ZENOLOGY_TABLE} name='ZENOLOGY' />
      <RolandTable
        table={VIRTUAL_INSTRUMENTS_TABLE}
        name='Virtual Instruments'
      />
      <div className='table-section__text'>
        <Paragraph text={LANGUAGE_SETTINGS.patchesAndPatternsExplanation} />
      </div>
      <RolandTable
        table={SOFTWARE_EFFECTS}
        name='Software Effects'
      />
      <RolandTable table={PATCHES_TABLE} name='Patches & Patterns' />
      <RolandTable table={JAM_TRACKS_TABLE} name='Jam Tracks' />
      <RolandTable table={SAMPLE_CONTENT_TABLE} name='Samples' />
      <RolandTable table={SOLUTIONS_TABLE} name='Apps' />
    </div>
    <div className='table-section__text'>
      <Paragraph text={LANGUAGE_SETTINGS.rolandTableExplanation} />
      <Paragraph text={LANGUAGE_SETTINGS.rolandTableExplanationTwo} />
    </div>
  </div>
);
